import React, { useContext, useState } from "react";
import "../account.css";
import "./accountContact.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import generalRequest from "../../../request/generalRequest";
import BannerMessageFixed from "../../common/bannerMessageFixed/bannerMessageFixed";
import { Clock, MessageSquare, Send } from "lucide-react";

const AccountContact = () => {
    const { language, userData } = useContext(CombinedContext);

    const t = translations[language]?.account?.contact || {};

    const [form, setForm] = useState({
        email: userData?.user?.email || "",
        phone: "",
        subject: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setForm((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.message) {
            setError(t.errorRequired || t.errorFailed);
            return;
        }

        try {
            setLoading(true);
            setError(null);

            await generalRequest.contactSupport(form);

            setSuccess(true);
            setTimeout(() => {
                setSuccess(false);
            }, 5000);
            setForm((prev) => ({
                ...prev,
                subject: "",
                message: "",
                phone: "",
            }));
        } catch (err) {
            setError(err.message || "Failed to send message");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="ac-page apct">
            <header className="ac-head">
                {/* <span className="ac-eyebrow">{translations[language]?.account?.menu?.contact || "Contact"}</span> */}
                <h1 className="ac-title">{t.title}</h1>
                {t.subtitle && <p className="ac-sub">{t.subtitle}</p>}
            </header>

            <section className="ac-card apct-card">
                <div className="ac-card-head">
                    <span className="ac-icon">
                        <MessageSquare size={16} />
                    </span>
                    <h3>{t.title}</h3>
                </div>

                <form className="ac-card-body" onSubmit={handleSubmit}>
                    <div className="apct-grid">
                        <div className="ac-field">
                            <label className="ac-label" htmlFor="apct-email">
                                {t.email}
                            </label>
                            <input
                                id="apct-email"
                                className="ac-input"
                                type="email"
                                name="email"
                                placeholder={t.email}
                                value={form.email}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="ac-field">
                            <label className="ac-label" htmlFor="apct-phone">
                                {t.phone}
                            </label>
                            <input
                                id="apct-phone"
                                className="ac-input"
                                type="text"
                                name="phone"
                                placeholder={t.phone}
                                value={form.phone}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="ac-field">
                        <label className="ac-label" htmlFor="apct-subject">
                            {t.subject}
                        </label>
                        <input
                            id="apct-subject"
                            className="ac-input"
                            type="text"
                            name="subject"
                            placeholder={t.subject}
                            value={form.subject}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="ac-field">
                        <label className="ac-label" htmlFor="apct-message">
                            {t.message || t.subject}
                        </label>
                        <textarea
                            id="apct-message"
                            className="ac-textarea"
                            name="message"
                            placeholder={t.messagePlaceholder}
                            value={form.message}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {t.responseNote && (
                        <div className="ac-note">
                            <Clock size={14} />
                            <span>{t.responseNote}</span>
                        </div>
                    )}

                    <button type="submit" disabled={loading} className="ac-btn apct-submit">
                        <Send size={15} />
                        {loading ? t.sending : t.send}
                    </button>
                </form>
            </section>

            <BannerMessageFixed
                type={error ? "error" : success ? "success" : "info"}
                text={error ? error : success ? t.success : null}
            />
        </div>
    );
};

export default AccountContact;
